import React from 'react';
import { useMachine } from '@xstate/react';

import { CountryCodes } from 'src/common/enums';
import { NewSearchLocation } from 'src/global/models/NewSearchLocation';

import { useGenerateLocationQuery } from './generateSearchQuery';
import keywordSearchMachine from './KeywordSearchMachine';

export const useKeywordSearchMachine = (
  locationResponse: NewSearchLocation[],
  locationSearchValue: NewSearchLocation,
  selectedCountry: CountryCodes,
  setLocationSearchFieldKeyword: (
    e: React.SetStateAction<NewSearchLocation>
  ) => void,
  setIsLocationError: (e: React.SetStateAction<boolean>) => void,
  setLocationResponse: (e: React.SetStateAction<NewSearchLocation[]>) => void,
  isLocationError: boolean
) => {
  const [currentState, send] = useMachine(keywordSearchMachine);
  const {
    context: { searchKeyword },
  } = currentState;

  const locationQuery = useGenerateLocationQuery(
    locationResponse,
    locationSearchValue,
    selectedCountry
  );

  const onKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    send('UPDATE_SEARCH_KEYWORD', { searchKeyword: e.target.value });

  const onKeywordClick = (value: React.SetStateAction<string>) =>
    send('UPDATE_SEARCH_KEYWORD', { searchKeyword: value });
  const onLocationClick = (location: NewSearchLocation) => {
    setLocationSearchFieldKeyword(location);
    send('UPDATE_LOCATION_KEYWORD', { locationKeyword: location.label });
  };
  const onLocationErrorChange = (result: React.SetStateAction<boolean>) =>
    setIsLocationError(result);
  const onLocationResponseChange = (
    response: React.SetStateAction<NewSearchLocation[]>
  ) => setLocationResponse(response);

  const onSearchEnter = (
    e:
      | React.KeyboardEvent<HTMLInputElement>
      | React.MouseEvent<HTMLLIElement, MouseEvent>,
    suggestions: string[],
    selectionCursor?: number
  ) => {
    send('ON_ENTER', {
      suggestion: suggestions[selectionCursor],
      locationValid: !isLocationError,
    });
    e.currentTarget.blur();
  };

  const onLocationEnter = () =>
    send('ON_ENTER', { locationValid: !isLocationError });
  const onSearchButtonClick = () =>
    send('ON_SEARCH_BUTTON_CLICK', { locationValid: !isLocationError });

  return {
    currentState,
    send,
    searchKeyword,
    locationQuery,
    onKeywordChange,
    onKeywordClick,
    onLocationClick,
    onLocationErrorChange,
    onLocationResponseChange,
    onSearchEnter,
    onLocationEnter,
    onSearchButtonClick,
  };
};
